//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Paging',
  props: {
    productlistlength: {type: Number},
    itemcount: {type: Number},
  },
  data() {
    return {
      sortByItems: [
        {text: 'Our Top Picks', value: 'rank'},
        {text: 'New Arrivals', value: 'date'},
        {text: 'Best Sellers', value: 'sellers'},
        {text: 'Price High to Low', value: 'descending'},
        {text: 'Price Low to High', value: 'ascending'},
      ],
      viewItems: [
        {text: '16', value: 16},
        {text: '32', value: 32},
        {text: '48', value: 48},
        {text: '100', value: 100},
        {text: '200', value: 200},
      ],
      page: 1,
      selectedSortBy: {text: 'Our Top Picks', value: 'rank'},
      selectedPageSize: {text: '16', value: 16},
    }
  },
  methods: {
    getControlId(name) {
      return this.$attrs.id + '_' + name
    },
    pageNumberChanged(value) {
      this.page = value
      this.reloadList()
    },
    getPages() {
      const pages = []
      const pageCount = this.itemcount / this.selectedPageSize.value ?? 16
      for (let i = 1; i < pageCount + 1; i++) {
        pages.push(i)
      }
      return pages
    },
    selectedSortByChanged(event) {
      this.selectedSortBy = this.sortByItems[event.target.options.selectedIndex]
      this.reloadList()
    },
    selectedPageSizeChanged(event) {
      this.selectedPageSize = this.viewItems[event.target.options.selectedIndex]
      this.reloadList()
    },
    getPagingInfo() {
      return {
        sortBy: this.selectedSortBy,
        pageSize: this.selectedPageSize,
        pageNumber: this.page,
      }
    },
    reloadList() {
      const paging = this.getPagingInfo()
      this.$emit('reloadlist', paging)
    },
    setupPagingInfo(pager) {
      if (pager) {
        // this.selectedSortBy = pager.sortBy
        // const sortBySelect = document.getElementById(
        //   this.getControlId('sortby')
        // )
        // sortBySelect.value = pager.sortBy.value

        this.selectedPageSize = pager.pageSize
        const pageSizeSelect = document.getElementById(
          this.getControlId('pagesize')
        )
        pageSizeSelect.value = pager.pageSize.value

        this.page = pager.pageNumber
      }
    },
  },
}
